import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, FormControl } from 'react-bootstrap'
import './bankIdSeContentBlock.scss'
import authenticationService from 'services/authServices'
import { getReturnUrl } from 'utils/authHelpers'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import ErrorBox from 'components/message-boxes/error-box/ErrorBox'

const BankIdTestAuthContentBlock = () => {
	const { t } = useTranslation()
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [error, setError] = useState<Error | undefined>()
	const [ssn, setSsn] = useState<string>('')

	const loginComplete = async () => {
		setError(undefined)
		setIsLoading(true)

		try {
			const response = await authenticationService.bankIdTestAuth(ssn)

			if (!response.ok) {
				setError(new Error('Failed to authenticate'))
				return
			}

			authenticationService.redirectTo(getReturnUrl(), response.secret)
		} catch (e) {
			setError(new Error(t('BankIdTestAuthError')))
		} finally {
			setIsLoading(false)
		}
	}

	return (
		<div className="bankid-se-container">
			{isLoading ? (
				<CircleSpinner />
			) : (
				<>
					<div className="login-description mb-4">
						Enter SSN to login
					</div>
					<FormControl
						placeholder={t('SSN')}
						className="mt-2"
						name="ssn"
						id="ssn"
						value={ssn}
						onChange={(e) => setSsn(e.target.value)}
					/>
					<Form.Control.Feedback type="invalid">
						{t('InvalidSsn')}
					</Form.Control.Feedback>

					{error && <ErrorBox message={error.message} css="mt-2" />}
					<button
						onClick={loginComplete}
						className="btn btn-primary mt-4">
						{t('Proceed')}
					</button>
				</>
			)}
		</div>
	)
}

export default BankIdTestAuthContentBlock
